import {api} from 'api';
import Button from 'components/buttons/Button';
import {useAuthContext} from 'context/AuthContext';
import {usePostApi} from 'hooks/usePostApi';
import React from 'react';

export const LogoutButton = () => {
   const {logout} = useAuthContext();

   const {request} = usePostApi(api.logout, {
      onSuccess: logout,
   });

   return (
      <Button
         color="primary"
         onClick={() => {
            request(null);
         }}
      >
         Logout
      </Button>
   );
};
